<template lang="pug">
BriqPanel.website-content-panel
  h2.mb-S Content on website
  p.subtitle This is the information used to show the product as an extra
  BriqMultilangueColumns(
    :showSecondColumn="showSecondColumn"
    :translationFields="translationFields"
    )
    WebsiteContentFields(
      :product="product"
      :vuelidate="vuelidate",
      :disabled="disabled",
      :horizontalAlignmentOptions="horizontalAlignmentOptions"
      :verticalAlignmentOptions="verticalAlignmentOptions"
      )
    template(v-slot:secondary)
      WebsiteContentFields(
        v-if="translationModel"
        :product="translationModel"
        :vuelidate="vuelidate",
        :disabled="disabled",
        :horizontalAlignmentOptions="horizontalAlignmentOptions"
        :verticalAlignmentOptions="verticalAlignmentOptions"
        :showSecondColumn="showSecondColumn"
        )
</template>

<script>
import ImagePicker from '@v/components/ImagePicker.vue'
import BriqMultilangueColumns from '@v/components/BriqMultilanguageColumns.vue'
import WebsiteContentFields from '@v/inventory/products/edit/ProductFields/WebsiteContentFields.vue'
import modelMixin from '@v/mixins/modelMixin'

export default {
  name: 'WebsiteContentPanel',
  components: {
    ImagePicker,
    BriqMultilangueColumns,
    WebsiteContentFields,
  },
  mixins: [modelMixin({ type: Object, name: 'product' })],
  props: {
    vuelidate: Object,
    disabled: Boolean,
    horizontalAlignmentOptions: Object,
    verticalAlignmentOptions: Object,
    showSecondColumn: Boolean,
    activeCulture: Object,
  },
  computed: {
    translationModel() {
      if (!this.activeCulture) {
        return null
      }
      const key = this.activeCulture.Name
      return this.product.TranslationInfo.Translations?.[key]
    },
    translationFields() {
      // todo: refactor to make it work with model field name instead of label
      return ['Public name', 'Description']
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~@v/variables.styl'

h2
  margin-bottom 20px
.subtitle
  padding-top 4px
  margin-top -20px
  {typeSmall}
</style>

<style lang="stylus">
@import '~@v/variables.styl'

.website-content-panel .briq-form-element
  margin-bottom space-S
</style>
